import { extend, $$ } from './helper-functions'
import Splide from '@splidejs/splide'

export class GalleryVariant1 {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.gallery--variant-1'
    }, selectors)

    this.classes = extend({
    }, classes)

    this.galleries = $$(this.selectors.block)
  }

  init () {
    this.events()
  }

  events () {
    this.galleries.forEach(gallery => {
      new Splide(gallery, {
        type: 'loop',
        perPage: 3,
        gap: '10vw',
        speed: 500,
        focus: 'center',
        pagination: false,
        updateOnMove: true,
        breakpoints: {
          767: {
            perPage: 1
          }
        }
      }).mount()
    })
  }
}

export default GalleryVariant1
